import {styled} from '@mui/material';

export const Container = styled('div')(() => ({}));

export const FieldContainer = styled('div')(() => ({
  marginBottom: 10,
}));
